// Trust level, health and achievement badge metadata aligned with the
// avocash design system tokens (design-support/avocash_revised_design_system.html).
//
// Trust levels follow the growth engine tiers surfaced by the growth API.
// Colors map 1:1 to brand tokens so badges stay consistent across
// MemberCard, group cards and the growth dashboard.
//
// Icons must exist in the F7 Icons font: `trophy_fill` and `diamond_fill` render
// blank there, so those levels use `rosette` and `star_circle_fill`.
export const TRUST_LEVELS = [
  { code: 'NEW',      label: 'growth.trustLevel.new',      icon: 'star',             color: '#8E8E93', bg: '#F4F7F2' },
  { code: 'BRONZE',   label: 'growth.trustLevel.bronze',   icon: 'star_fill',        color: '#9A6B3F', bg: '#FAEEDA' },
  { code: 'SILVER',   label: 'growth.trustLevel.silver',   icon: 'staroflife_fill',  color: '#6B7280', bg: '#F1EFE8' },
  { code: 'GOLD',     label: 'growth.trustLevel.gold',     icon: 'rosette',          color: '#C9A84C', bg: '#FDF6E3' },
  { code: 'PLATINUM', label: 'growth.trustLevel.platinum', icon: 'star_circle_fill', color: '#6B46C1', bg: '#F5F0FF' },
  { code: 'DIAMOND',  label: 'growth.trustLevel.diamond',  icon: 'sparkles',         color: '#3B4FCA', bg: '#EBF0FC' },
]

export const TRUST_THRESHOLDS = {
  NEW: 0, BRONZE: 100, SILVER: 300, GOLD: 700, PLATINUM: 1500, DIAMOND: 5000,
}

export function trustMeta(code) {
  return TRUST_LEVELS.find((t) => t.code === code) ?? TRUST_LEVELS[0]
}

export function trustProgress(trustPoints, trustLevel) {
  const levels = TRUST_LEVELS.map((t) => t.code)
  const current = TRUST_THRESHOLDS[trustLevel] ?? 0
  const next = levels.find((l) => TRUST_THRESHOLDS[l] > current)
  const target = next ? TRUST_THRESHOLDS[next] : current
  return target > current ? Math.min(100, Math.round((trustPoints / target) * 100)) : 100
}

export function nextTrustLevel(trustLevel) {
  const levels = TRUST_LEVELS.map((t) => t.code)
  const idx = levels.indexOf(trustLevel)
  return idx >= 0 && idx < levels.length - 1 ? levels[idx + 1] : 'MAX'
}

// Health score bands → brand colour + label.
export function healthMeta(score) {
  if (score == null) return { label: 'growth.healthMeta.na', color: '#8E8E93', bg: '#F4F7F2' }
  if (score >= 80) return { label: 'growth.healthMeta.excellent', color: '#1A6B42', bg: '#EAF2EB' }
  if (score >= 60) return { label: 'growth.healthMeta.solid', color: '#5F8A4A', bg: '#EAF2EB' }
  if (score >= 40) return { label: 'growth.healthMeta.needsWork', color: '#C9A84C', bg: '#FDF6E3' }
  return { label: 'growth.healthMeta.critical', color: '#C0440A', bg: '#FDECEA' }
}